import { FC } from "react";
import Radio from "../../../Radio";
import { EPaymentMode } from "../StudentPaymentPane";
import { useTranslation } from "react-i18next";
import Button from "../../../Button";
import PaymentButtons from "./PaymentButtons";

interface IProps {
  paymentMode: EPaymentMode;
  onSetPaymentMode: (mode: EPaymentMode) => void;
  setAddPaymentVisible: (visible: boolean) => void;
  setDownloadCertificateVisible: (visible: boolean) => void;
};

const PaymentPaneHeader: FC<IProps> = ({
  paymentMode,
  onSetPaymentMode,
  setAddPaymentVisible,
  setDownloadCertificateVisible,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Radio
            checked={paymentMode === EPaymentMode.PaymentToBeMade}
            onChange={() => onSetPaymentMode(EPaymentMode.PaymentToBeMade)}
            text={t('student.student.option16')}
          />
          <Radio
            className="ml-4"
            checked={paymentMode === EPaymentMode.PaymentMade}
            onChange={() => onSetPaymentMode(EPaymentMode.PaymentMade)}
            text={t('student.student.option17')}
          />
        </div>
      </div>
      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic pink-line"
            onClick={() => setDownloadCertificateVisible(true)}
            text={t('student.student.button14')}
          />
        </div>
        <div className="comm-btn__area right">
          <PaymentButtons
            setAddPaymentVisible={setAddPaymentVisible}
            onSetPaymentMode={onSetPaymentMode}
          />
        </div>
      </div>
    </>    
  );
};

export default PaymentPaneHeader;